// extracted by mini-css-extract-plugin
export default {"external":"a9Gtdf","badge":"b9Gtdf"};